module.exports = __webpack_public_path__ + "media/images/thumbs/biology/m_animation_translation_14-3e8b449b948235f9bd5311f60c6a3510.jpg";